import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { PermissionsService } from '../services/permissions.service';
import { AuthService } from '../services/auth.service';

/**
 * Prima pagina che l'utente può davvero aprire.
 *
 * La radice e il wildcard puntavano a `/dashboard`, che però è protetta da
 * `can_search_calls`: chi non ce l'ha veniva sbattuto su `/unauthorized` appena
 * entrato, senza aver cliccato niente. Qui si sceglie invece la prima
 * destinazione consentita, nello stesso ordine del menù laterale.
 *
 * L'ordine rispecchia `navItems()` in `layouts/shell/shell.component.ts`: se
 * là si aggiunge una voce, conviene aggiungerla anche qui. Dimenticarsene non
 * rompe niente — si atterra su Preferenze, che non richiede permessi ed è
 * l'ultima riga di questo elenco proprio per questo.
 */
const CANDIDATI: ReadonlyArray<{ route: string; permesso?: string }> = [
  { route: '/dashboard',       permesso: 'can_search_calls' },
  { route: '/conversations',   permesso: 'can_use_chat' },
  { route: '/search/calls',    permesso: 'can_search_calls' },
  { route: '/search/semantic', permesso: 'can_semantic_search' },
  { route: '/search/geo',      permesso: 'can_geo_search' },
  { route: '/collections',     permesso: 'can_add_to_collections' },
  { route: '/my-messages' },
  { route: '/profile' },
];

export const homeRedirect = (): UrlTree => {
  const perms  = inject(PermissionsService);
  const router = inject(Router);
  if (inject(AuthService).accessoNegato()) {
    return router.parseUrl('/accesso-negato');
  }
  const scelta = CANDIDATI.find(c => !c.permesso || perms.has(c.permesso));
  return router.parseUrl(scelta?.route ?? '/profile');
};
